import { useState, useEffect } from "react";

import { directorioMiembros, guardarVarias, listaNinos, listar, unir } from "../../services/datos";
import { avisar } from "../../shared/avisos";
import Esqueleto from "../../shared/components/Esqueleto";

function AsistenciaNinos({ usuario }) {
  const [servicios, setServicios] = useState([]);
  const [ninos, setNinos] = useState([]);
  const [servicio, setServicio] = useState(null);
  const [asistencia, setAsistencia] = useState({});
  const [cargando, setCargando] = useState(false);
  const [buscar, setBuscar] = useState("");

  useEffect(() => {
    const fallo = (e) => avisar(e.message, "error");
    listar("servicios", { select: "*, tipos_servicio(nombre, dirigido_a)", orden: "fecha" }).then(setServicios).catch(fallo);
    Promise.all([listaNinos(), directorioMiembros()])
      .then(([lista, personas]) => setNinos(unir(lista, "tutor_id", personas, "miembros")))
      .catch(fallo);
  }, []);

  const seleccionar = (s) => {
    setServicio(s);
    setCargando(true);
    listar("asistencia_ninos", { filtros: { servicio_id: s.id } })
      .then((data) => {
        const map = {};
        data.forEach((a) => { map[a.nino_id] = a.presente; });
        setAsistencia(map);
        setCargando(false);
      })
      .catch((e) => { setCargando(false); avisar(e.message, "error"); });
  };

  const toggle = (id) => setAsistencia((prev) => ({ ...prev, [id]: !prev[id] }));

  const guardar = () => {
    if (!servicio) return;
    const registros = Object.entries(asistencia).map(([nino_id, presente]) => ({ servicio_id: servicio.id, nino_id: parseInt(nino_id), presente }));
    guardarVarias("asistencia_ninos", registros, "servicio_id,nino_id")
      .then(() => avisar("Asistencia guardada correctamente", "exito"))
      .catch((e) => avisar(e.message, "error"));
  };

  const ninosFiltrados = ninos.filter((n) => {
    const texto = `${n.nombres} ${n.apellidos}`.toLowerCase();
    return texto.includes(buscar.toLowerCase()) || `${n.miembros?.nombres || ""} ${n.miembros?.apellidos || ""}`.toLowerCase().includes(buscar.toLowerCase());
  });

  const presentes = Object.values(asistencia).filter(Boolean).length;
  const totalNinos = ninos.length;

  return (
    <div className="p-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between mb-6">
        <div>
          <h2 className="titulo-pagina">Asistencia Infantil</h2>
          <p className="text-gray-400 text-sm mt-1">Registra asistencia de los niños por servicio</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[280px_minmax(0,1fr)] gap-6 mb-6">
        <div className="panel p-4">
          <p className="text-gray-400 text-sm">Servicios disponibles</p>
          <p className="text-white font-black text-4xl mt-2">{servicios.length}</p>
          <div className="mt-4 space-y-3">
            {servicios.map((s) => (
              <button
                key={s.id}
                onClick={() => seleccionar(s)}
                className={`w-full text-left rounded-2xl border p-3 transition ${servicio?.id === s.id ? "border-dorado bg-oscuro" : "border-gray-700 hover:border-dorado"}`}>
                <p className="text-white text-sm font-semibold">{s.tipos_servicio?.nombre || s.titulo}</p>
                <p className="text-gray-400 text-xs mt-1">{s.fecha}</p>
              </button>
            ))}
          </div>
        </div>

        <div className="panel p-4">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-4">
            <div>
              <h3 className="text-xl font-black uppercase tracking-tight text-white">{servicio ? servicio.tipos_servicio?.nombre || servicio.titulo : "Seleccione un servicio"}</h3>
              {servicio && <p className="text-gray-400 text-sm">{servicio.fecha}</p>}
            </div>
            <div className="grid grid-cols-2 gap-3 w-full md:w-auto">
              <div className="rounded-2xl bg-oscuro p-3 text-center border border-gray-700">
                <p className="text-gray-400 text-xs">Presentes</p>
                <p className="text-white font-black text-2xl">{presentes}</p>
              </div>
              <div className="rounded-2xl bg-oscuro p-3 text-center border border-gray-700">
                <p className="text-gray-400 text-xs">Total niños</p>
                <p className="text-white font-black text-2xl">{totalNinos}</p>
              </div>
            </div>
          </div>

          {!servicio ? (
            <div className="flex items-center justify-center h-56">
              <p className="text-gray-400">Elige un servicio para ver la lista de asistencia.</p>
            </div>
          ) : (
            <>
              <input
                type="text"
                value={buscar}
                onChange={(e) => setBuscar(e.target.value)}
                placeholder="Buscar niño o tutor"
                className="mb-4 campo"
              />

              {cargando ? (
                <Esqueleto />
              ) : (
                <div className="space-y-3 max-h-[65vh] overflow-y-auto pr-1">
                  {ninosFiltrados.map((n) => (
                    <button
                      key={n.id}
                      onClick={() => toggle(n.id)}
                      className={`w-full text-left rounded-2xl border p-4 flex items-center justify-between gap-3 transition ${asistencia[n.id] ? "border-dorado bg-oscuro" : "border-gray-700 hover:border-dorado"}`}>
                      <div>
                        <p className="text-white font-semibold">{n.nombres} {n.apellidos}</p>
                        <p className="text-gray-400 text-xs">Tutor: {n.miembros?.nombres || "Sin tutor"}</p>
                      </div>
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${asistencia[n.id] ? "bg-dorado border-dorado" : "border-gray-500"}`}>
                        {asistencia[n.id] && <span className="text-oscuro text-xs font-bold">✓</span>}
                      </div>
                    </button>
                  ))}
                </div>
              )}

              <button onClick={guardar} className="w-full mt-4 btn-primario">Guardar asistencia</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AsistenciaNinos;
